import FinanceXVendors from './FinanceXVendors.container';

export default FinanceXVendors;
